import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/hamburger-button.css';

/**
 * Animated hamburger button that transforms into an X when open
 * Follows ARIA guidelines for accessible menu buttons
 */
const HamburgerButton = ({ isOpen, onClick, ariaLabel = "Toggle menu", controlsId }) => {
  return (
    <motion.button
      className="hamburger-button"
      onClick={onClick}
      aria-label={ariaLabel}
      aria-expanded={isOpen}
      aria-controls={controlsId || undefined}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="hamburger-icon">
        {/* Top line */}
        <motion.span
          className="hamburger-line"
          animate={{
            rotate: isOpen ? 45 : 0,
            y: isOpen ? 8 : 0,
          }}
          transition={{
            duration: 0.3,
            ease: [0.4, 0, 0.2, 1],
          }}
        />

        {/* Middle line */}
        <motion.span
          className="hamburger-line"
          animate={{
            opacity: isOpen ? 0 : 1,
            x: isOpen ? -10 : 0,
          }}
          transition={{
            duration: 0.2,
            ease: [0.4, 0, 0.2, 1],
          }}
        />

        {/* Bottom line */}
        <motion.span
          className="hamburger-line"
          animate={{
            rotate: isOpen ? -45 : 0,
            y: isOpen ? -8 : 0,
          }}
          transition={{
            duration: 0.3,
            ease: [0.4, 0, 0.2, 1],
          }}
        />
      </div>
    </motion.button>
  );
};

export default HamburgerButton;
